import { TfHullEvaluationAction, TfHullEvaluationVessel } from "../models/tf-hull-evaluations.models";

interface Props {
  action: TfHullEvaluationAction;
  onClose: () => void;
  vessels: TfHullEvaluationVessel[];
}

const TfHullEvaluationActionModal = ({ action, onClose, vessels }: Props) => {
  const contractCount = vessels.filter((vessel) => vessel.contract).length;
  const actionLabel = action === "request" ? "Requests" : "Reminders";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true" aria-labelledby="tf-hull-action-title" data-test={`tf-hull-${action}-modal`}>
      <div className="w-full max-w-3xl rounded-xl bg-white p-6 text-gray-900 shadow-xl">
        <h2 id="tf-hull-action-title" className="text-center text-2xl font-semibold">!!! ATTENTION !!!</h2>
        <p className="mt-5 text-center text-lg">You&apos;re about to send</p>
        <p className="text-center text-4xl font-bold text-[#d64550]">{contractCount}</p>
        <p className="text-center text-xl font-semibold">Tech Form {actionLabel}</p>
        <div className="mt-5 max-h-56 overflow-auto rounded border">
          <table className="w-full text-sm">
            <thead><tr><th className="p-2 text-left">IMO</th><th className="p-2 text-left">Vessel Name</th><th className="p-2 text-left">Email</th></tr></thead>
            <tbody>
              {vessels.map((vessel) => (
                <tr key={`${vessel.imo}-${vessel.contract ?? "no-contract"}`} className="border-t">
                  <td className="p-2">{vessel.imo}</td>
                  <td className="p-2">{vessel.vesselName}</td>
                  <td className="p-2">{vessel.vesselEmail ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-amber-700">The original send action uses an external Power Automate flow and is unavailable in this Snowflake-backed migration.</p>
        <div className="mt-5 flex justify-center gap-3">
          <button type="button" onClick={onClose} className="rounded bg-[#d64550] px-6 py-2 font-semibold text-white" data-test="tf-hull-action-back">Back</button>
          <button type="button" disabled className="rounded bg-gray-300 px-6 py-2 font-semibold text-gray-600" title="External Power Automate flow is not migrated">Send {actionLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default TfHullEvaluationActionModal;
